
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-smartphone",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.048 32H.954C.427 32 0 31.548 0 30.993s.426-1.007.954-1.007h22.094c.527 0 .952.451.952 1.007S23.575 32 23.048 32zm8.001 0h-4.095c-.527 0-.954-.452-.954-1.007s.427-1.007.954-1.007h4.095c.527 0 .951.451.951 1.007S31.576 32 31.049 32zM9.063 28.006a.986.986 0 01-.996-.988V3.575c0-.666.391-1.41.779-1.798l.98-1.021C10.272.306 11.01 0 11.627 0h7.426a4.95 4.95 0 013.543 1.493 5.036 5.036 0 011.458 3.567v12.973l.011 2.769a.932.932 0 01-.011.388v3.29c0 .623-.305 1.363-.744 1.8l-.99.998c-.437.437-1.173.728-1.789.728H9.063zm6.245-1.915c.625 0 1.131-.509 1.131-1.135 0-.63-.507-1.138-1.131-1.138s-1.132.508-1.132 1.138c0 .626.508 1.135 1.132 1.135zm-5.249-4.125H20.53a.86.86 0 00.383-.159l.992-.998a.864.864 0 00.158-.383V5.057a3.036 3.036 0 00-.884-2.155 2.964 2.964 0 00-2.125-.9h-7.426a.865.865 0 00-.38.159l-.982 1.021a.938.938 0 00-.206.404v18.379z"}})])
          )
        }
      }
    